var trackingConfig = {
    ga4gid: 'G-ZY91MXBDB9',
    prefix: 'conversional',
    trackerName: 'conversionalTracker',
    ga4TrackerName: 'conversionalGA4Tracker',
    journeyId: null
};
export default trackingConfig;
